import { Link, useNavigate } from 'react-router-dom';
import { useAuth, ROLE_LABELS } from '../../context/AuthContext';
import { Button } from '../ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';
import { User, SignOut, GraduationCap, BookOpen, Certificate, ChartBar, Users } from '@phosphor-icons/react';

export function Header() {
  const { user, logout, canAccessAdmin } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  return (
    <header className="bg-white/80 backdrop-blur-xl border-b border-[#2C3E50]/10 z-50 sticky top-0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center gap-2" data-testid="logo-link">
            <img 
              src="https://customer-assets.emergentagent.com/job_tecno-training/artifacts/iaun5cww_LOGO_TS%402x.png" 
              alt="Tecnoservice" 
              className="h-10 object-contain"
            />
          </Link>

          <nav className="hidden md:flex items-center gap-6">
            <Link 
              to="/" 
              className="text-[#5C6B7A] hover:text-[#2C3E50] transition-colors font-medium"
              data-testid="nav-home"
            >
              Inicio
            </Link>
            <Link 
              to="/courses" 
              className="text-[#5C6B7A] hover:text-[#2C3E50] transition-colors font-medium"
              data-testid="nav-courses"
            >
              Cursos
            </Link>
            {user && (
              <Link 
                to="/my-learning" 
                className="text-[#5C6B7A] hover:text-[#2C3E50] transition-colors font-medium"
                data-testid="nav-my-learning"
              >
                Meu Aprendizado
              </Link>
            )}
            {canAccessAdmin && (
              <Link 
                to="/admin" 
                className="text-[#5C6B7A] hover:text-[#2C3E50] transition-colors font-medium"
                data-testid="nav-admin"
              >
                Admin
              </Link>
            )}
          </nav>

          <div className="flex items-center gap-3">
            {user ? (
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <Button 
                    variant="ghost" 
                    className="flex items-center gap-2"
                    data-testid="user-menu-trigger"
                  >
                    <div className="w-8 h-8 rounded-full bg-[#2C3E50] flex items-center justify-center">
                      <User size={18} className="text-white" />
                    </div>
                    <span className="hidden sm:inline text-[#2C3E50] font-medium">
                      {user.name}
                    </span>
                  </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end" className="w-56">
                  <div className="px-3 py-2">
                    <p className="text-sm font-medium text-[#1A252F]">{user.name}</p>
                    <p className="text-xs text-[#5C6B7A]">{user.email}</p>
                    <p className="text-xs text-[#27AE60] mt-1">{ROLE_LABELS[user.role] || user.role}</p>
                  </div>
                  <DropdownMenuSeparator />
                  <DropdownMenuItem asChild>
                    <Link to="/my-learning" className="flex items-center gap-2 cursor-pointer" data-testid="menu-my-learning">
                      <BookOpen size={16} />
                      Meu Aprendizado
                    </Link>
                  </DropdownMenuItem>
                  <DropdownMenuItem asChild>
                    <Link to="/certificates" className="flex items-center gap-2 cursor-pointer" data-testid="menu-certificates">
                      <Certificate size={16} />
                      Meus Certificados
                    </Link>
                  </DropdownMenuItem>
                  {canAccessAdmin && (
                    <>
                      <DropdownMenuSeparator />
                      <DropdownMenuItem asChild>
                        <Link to="/admin" className="flex items-center gap-2 cursor-pointer" data-testid="menu-admin">
                          <ChartBar size={16} />
                          Painel de Controle
                        </Link>
                      </DropdownMenuItem>
                      <DropdownMenuItem asChild>
                        <Link to="/admin/users" className="flex items-center gap-2 cursor-pointer" data-testid="menu-users">
                          <Users size={16} />
                          Gerenciar Usuarios
                        </Link>
                      </DropdownMenuItem>
                    </>
                  )}
                  <DropdownMenuSeparator />
                  <DropdownMenuItem 
                    onClick={handleLogout}
                    className="flex items-center gap-2 text-[#E74C3C] cursor-pointer"
                    data-testid="menu-logout"
                  >
                    <SignOut size={16} />
                    Sair
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>
            ) : (
              <>
                <Link to="/login">
                  <Button 
                    variant="ghost" 
                    className="text-[#2C3E50] font-medium"
                    data-testid="login-btn"
                  >
                    Entrar
                  </Button>
                </Link>
                <Link to="/register">
                  <Button 
                    className="bg-[#2C3E50] text-white hover:bg-[#1A252F] font-medium"
                    data-testid="register-btn"
                  >
                    Comecar
                  </Button>
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
